// extracted by mini-css-extract-plugin
export default {"root":"col_root__Jlfs-","container":"col_container__WPm9G"};